import React, { createContext, useContext, useState } from 'react';
import { MandatoryChildren } from '../models/children-props';
import { AppContext, AppEnvironment } from './AppProvider';
import { useUserData } from '../hooks/useUserData';
import { UserAppRole } from '../models/graphql';
import { isImpersonating } from '../helpers/impersonationHelpers';

export const DevDebugContext = createContext({
  allowedDevDashboardAccess: false,
  allowedDevDashboardMutations: false,
  allowedDebugMode: false,
  debugMode: false,
  setDebugMode: (_val: boolean) => {}
});

export const DevDebugProvider = ({ children }: MandatoryChildren): JSX.Element => {
  const [debugModeState, setDebugModeState] = useState(!!localStorage.getItem('debugMode'));
  const { appConfig } = useContext(AppContext);
  const data = useUserData();
  const appRole = data.userData?.appRole;
  const allowedDevDashboardAccess =
    appConfig.environment === AppEnvironment.DEV || appRole === UserAppRole.ADMIN || isImpersonating();
  const allowedDevDashboardMutations = appConfig.environment === AppEnvironment.DEV;
  const allowedDebugMode =
    appConfig.environment === AppEnvironment.DEV || appRole === UserAppRole.ADMIN || isImpersonating();

  const setDebugMode = (val: boolean) => {
    setDebugModeState(val);
    if (val) {
      localStorage.setItem('debugMode', '1');
    } else {
      localStorage.removeItem('debugMode');
    }
  };

  const value = {
    allowedDevDashboardAccess,
    allowedDevDashboardMutations,
    allowedDebugMode,
    debugMode: allowedDebugMode && debugModeState,
    setDebugMode
  };
  return <DevDebugContext.Provider value={value}>{children}</DevDebugContext.Provider>;
};
